import React from "react";

import Box from "@mui/material/Box";

interface DashboardCardProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ children, style, className }) => {
  return (
    <Box
      className={className}
      style={style}
      sx={{
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderRadius: "5px",
        boxShadow: "0px 0px 6px 2px rgba(0,0,0,0.16)",
        overflow: "hidden",
        padding: "1rem",
      }}
    >
      {children}
    </Box>
  );
};

export default DashboardCard;
